module.exports = __webpack_public_path__ + "img/21.aa8b4c3d.jpg";